import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

const FormErrors = ( { mapFormErrors } ) => {
	return (
		<div
			style={ {
				bottom: '2rem',
				boxSizing: 'border-box',
				boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.1)',
				margin: '3rem 2rem 0',
				position: 'sticky'
			} }
		>
			<Message
				error
				size="small"
			>
				<Message.Header>
								There are errors in your submission.
					<br />
								Please correct the following fields.
				</Message.Header>
				<br />
				<Message.List>
					{ mapFormErrors() }
				</Message.List>
			</Message>
		</div>
	);
};

FormErrors.propTypes = { mapFormErrors: PropTypes.func.isRequired };

export default FormErrors;
